module.exports = __webpack_public_path__ + "img/empty.d582e3b5.svg";